module.exports = __webpack_public_path__ + "static/media/iconExam.bed374b7.svg";